import { ColumnsType } from "antd/lib/table/interface";
import Currency from "components/Currency";
import { BreakerCustomerSearchWithOwner } from "components/EntityTableSearch";
import MultiValueDisplay from "components/MultiValueDisplay";
import { BreakerCustomerSearchResult, BreakerTransaction } from "models/breaker";
import { TransactionType, TransactionTypeNames } from "models/transactions";
import { useState } from "react";
import { localizedDate } from "util/helpers";
import { createCustomFilter } from "util/table";
import BreakerTable from "./BreakerTable";
import BreakerTransactionTypeFilter from "./BreakerTransactionTypeFilter";
import { createBreakerHooks } from "./createBreakerHooks";

const hooks = createBreakerHooks<BreakerTransaction>('/breaker/transactions', {
    refreshOnNewTransaction: true,
    refreshOnCustomerEdit: true
});

const BreakerTransactions = () => {
    const [filter, setFilter] = useState<{
        customer?: BreakerCustomerSearchResult;
        type?: TransactionType;
    }>({});

    const columns: ColumnsType<BreakerTransaction> = [
        {
            title: <MultiValueDisplay title="User Name" subTitle="Email" titleColor="inherit" subTitleColor="inherit" />,
            dataIndex: "userName",
            key: "userId",
            ...createCustomFilter(
                BreakerCustomerSearchWithOwner,
                customer => setFilter({ customer }),
                filter.customer?.id
            ),
            render: (userName, rec) => (
                <MultiValueDisplay
                    title={userName}
                    subTitle={rec.userEmail}
                />
            ),
        },
        {
            title: "Date",
            dataIndex: "transactionDate",
            key: "date",
            render: localizedDate,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "desc",
        },
        {
            title: "Type",
            dataIndex: "transactionType",
            key: "transactionType",
            ...createCustomFilter(
                BreakerTransactionTypeFilter,
                type => setFilter({ type }),
                filter.type
            ),
            render: (t: TransactionType) => TransactionTypeNames[t]
        },
        {
            title: "Amount",
            dataIndex: "grossAmountInCents",
            key: "gross",
            align: "right",
            render: (a) => <Currency cents={a} />,
        },
        {
            title: "Fees",
            dataIndex: "feesInCents",
            key: "fees",
            align: "right",
            render: (a) => <Currency cents={-a} />,
        },
        {
            title: "Net",
            dataIndex: "netAmountInCents",
            key: "net",
            align: "right",
            render: (a) => <Currency cents={a} />,
        },
    ];

    return <BreakerTable
        hooks={hooks}
        columns={columns}
        noDataText="No transactions have been made!"
    />;
}

export default BreakerTransactions;